import {AfterViewInit, Component, NgZone, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {RecaptchaComponent} from 'ng-recaptcha';
import {Mask} from 'src/app/model/mask.model';
import {Usuario} from 'src/app/model/usuario.model';
import {first} from 'rxjs/operators';
import {GenericValidator} from 'src/app/generic-validator';
import {NotificationsService} from 'angular2-notifications';
import {GoogleAnalyticsService} from 'src/app/services/google-analytics.service';
import {ConfigurationService} from 'src/app/services/configuration.service';
import {UsuarioService} from 'src/app/services/usuario.service';

@Component({
  selector: 'app-cadastro-empresa',
  templateUrl: './cadastro-empresa.component.html',
  styleUrls: ['./cadastro-empresa.component.css']
})
export class CadastroEmpresaComponent implements OnInit, AfterViewInit {
    @ViewChild('rc', { static: true }) rc: RecaptchaComponent;
    captchaToken: string = '';
    cnpjmask = Mask.cnpj;
    telefonemask = Mask.telefone;
    model: any = {};
    showSpinner = false;
    reCaptchaKey: string;
    canSignUp: boolean = true;
    agenciaSelecionada: Number;

    constructor(
        private router: Router,
        private zone: NgZone,
        private usuarioService: UsuarioService,
        private _notificationService: NotificationsService,
        public googleAnalyticsService: GoogleAnalyticsService,
        private configService: ConfigurationService
    ) {
        this.onConfigLoad = this.onConfigLoad.bind( this );
        configService.loadConfigurations().subscribe( this.onConfigLoad );
    }

    ngOnInit() {
        this.googleAnalyticsService.eventEmitter("cadastro-empresa", "load", "page-load", 1);
        this.model = new Usuario();
        this.model.empresa = true;

        RecaptchaComponent.prototype.ngOnDestroy = function() {
            if (this.subscription) {
              this.subscription.unsubscribe();
            }
          }
    }

    ngAfterViewInit() {
        if ( this.canSignUp === false ) {
            this._notificationService.error('Cadastro', 'Não estamos aceitando novos cadastro no momento.');
            this.router.navigate(['app/login/empresa']);
        }
    }

    resolved(captchaResponse: string) {
        this.model.token = captchaResponse;
        this.captchaToken = captchaResponse;
    }

    onConfigLoad( config ) {
      this.reCaptchaKey = config.reCaptchaKey;
      this.agenciaSelecionada = config.agencyId;
      if ( config.features ) {
          this.canSignUp = config.features.signUp;
      }
    }

    efetuarCadastro() {

        if (this.model.senha !== this.model.csenha) {
            this._notificationService.error('Senha', 'O campo Senha está diferente do Confirma Senha.');
            this.rc.reset();
            return;
        }

        this.model.cpf =  this.model.cpf.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '');
        this.model.cpf =  this.model.cpf.replace('-', '');

        if (!GenericValidator.isValidCnpj(this.model.cpf)) {
            this._notificationService.error('Cadastro', 'CNPJ inválido.');
            this.rc.reset();
            return;
        }
        this.model.tenant = this.agenciaSelecionada;

        this.googleAnalyticsService.eventEmitter("cadastro-empresa", "button-click", "novo-cadastro", 2);

        this.showSpinner = true;
      this.usuarioService.postCadastro(this.model).pipe(first()).subscribe((result: Usuario) => {
        this._notificationService.success('Cadastro', 'Cadastro efetuado com sucesso.');
        const toast = this._notificationService.success('Cadastro', 'Direcionando para o login, aguarde...');
        this.googleAnalyticsService.eventEmitter("cadastro-empresa", "button-click", "sucesso", 3);
        if(result.userId) toast.timeoutEnd.pipe(first()).subscribe(() => {
          this.zone.run(() => {
            this.router.navigate(['app/dashboard']);
          });
        }); else {
          this._notificationService.success('Email enviado', 'Acesse seu email para confirmar o cadastro');
          this.router.navigate(['app/dashboard']);
        }
      }, (err) => {
        this.rc.reset();
        this.showSpinner = false;
        this.googleAnalyticsService.eventEmitter("cadastro-empresa", "button-click", "erro", 4);
      });
    }
}
